import { LightningElement,api} from "lwc";
import { ListItem, CustomLabelsMap } from "./types";
export type { ListItem };

export default class ClassPostPurchaseCard extends LightningElement {
    @api listitem: ListItem = null!;
    @api buttonDetailWes={
        id: "1",
        buttonLabel: {
            value: "",
            label: ""
        },
        variant: '',
        size: 'default',
        showWesButton: true
    };
    @api customLabelsMap: CustomLabelsMap = [];

    buttonHandler() {
        this.dispatchEventMethod("buttonclick",{ classId: this.listitem?.id, name: this.buttonDetailWes.buttonLabel.value, registerFlag : this.listitem?.registerFlag });
    }

    cancelClassHandler() {
        const eventName = ["Registered"].includes(this.listitem?.registerFlag) ? "Cancel Class" : "Cancel Waitlist";
        this.dispatchEventMethod("buttonclick",{ classId: this.listitem?.id, name: eventName, registerFlag : this.listitem?.registerFlag });
    }

    titleHandler() {
        this.dispatchEventMethod("buttonclick",{ classId: this.listitem?.id, name: "learningOfferingTitle", registerFlag : this.listitem?.registerFlag });
    }

    dispatchEventMethod(eventName: string, eventDetail: { classId: string, name: string ,registerFlag: string}){
        this.dispatchEvent(
            new CustomEvent(eventName, {
                detail: eventDetail,
            })
        );
    }

    private get showCancelClass() {
        return this.listitem?.cancellationFlag === "ALLOWED" ? true : false;
    }

    private get showCancelClassDisabled() {
        return this.listitem?.cancellationFlag === "DISABLED" ? true : false;
    }

    private get badgeColor() {
        return this.listitem?.badgeColor;
    }

    //Set value "In Person Class" in order render location
    private get showInperson() {
        return this.listitem?.badgeText !== "Virtual" ? true : false;
    }
   
    private get showLearner() {
        return this.listitem?.type === "postPurchase" ? true : false;
    }

    private get topMargin() {
        return this.listitem?.type === "postPurchase" ? "" : "margin: 5px 20px 5px 0px;";
    }

    private get showCompletedDate() {
        return (this.listitem?.type === "postPurchase" && this.listitem?.completedDateValue !== "") ? true :false;
    }

    private get showBrandButton() {
        let isBrandButton=["Waitlisted", "Registered"].includes(this.listitem?.registerFlag) || ["postPurchase"].includes(this.listitem?.type);
        if(isBrandButton){
          this.buttonDetailWes.variant = "primary";
        }
        return isBrandButton;
    }

    private get isDisabled() {
        return this.listitem?.availableToJoin === true ? false : true;
    }

    private get isArchived() {
        return this.listitem?.archived === true ? true : false;
    }

    private get cancelButtonLabel() {
        return ["Registered"].includes(this.listitem?.registerFlag)
        ? this.customLabelsMap.find((obj) => obj.key === "Cancel Class")?.value
        : this.customLabelsMap.find((obj) => obj.key === "Cancel Waitlist")
            ?.value;
    }

    private get isConvertedTime() {
        return this.listitem?.convertedTime === "" ? false : true;
    }
    
    connectedCallback(): void {
        this.createButtonData();
    }
      
    createButtonData(){
        if(["Registered"].includes(this.listitem?.registerFlag)){
            let buttonObject = this.listitem?.buttonArr?.find(btn => btn.value === 'join_now');
            if(buttonObject){
                this.setButtonData(String(buttonObject?.label),String(buttonObject?.value));
            }
        }
        if(["Waitlisted"].includes(this.listitem?.registerFlag)){
            let buttonObject = this.listitem?.buttonArr?.find(btn => btn.value === 'waitlisted');
            if(buttonObject){
                this.setButtonData(String(buttonObject?.label),String(buttonObject?.value));
            }
        }
        if(["postPurchase"].includes(this.listitem?.type)){
            let buttonObject = this.listitem?.buttonArr?.find(btn => btn.value === 'more_details');
            if(buttonObject){
                this.setButtonData(String(buttonObject?.label),String(buttonObject?.value));
            }
        }
    }
   
    setButtonData(buttonLabel : string, buttonValue : string){
        this.buttonDetailWes.buttonLabel.label=buttonLabel;
        this.buttonDetailWes.buttonLabel.value=buttonValue;
    }
}

